import { type FC, type HTMLAttributes } from 'react';

import { getClassNames } from '@eneco/sparky/util/css';

import { spanHeadingSStyle } from './CustomerReview.css';

type SpanHeadingSProps = HTMLAttributes<HTMLSpanElement>;

export const SpanHeadingS: FC<SpanHeadingSProps> = ({ className, ...props }) => (
  <span className={getClassNames(spanHeadingSStyle, className)} {...props} />
);
